// extracted by mini-css-extract-plugin
module.exports = {"main":"main___2acsD","content":"content___qm-eW","ant-typography-secondary":"ant-typography-secondary___3Srcs"};